/**
 * Route utama atau root ('/') untuk render component Frontend layout
 * supaya component dari frontend layout reusable tidak di load berulang2...
 */

import FrontendLayout from "layouts/FrontendLayout";
import { BrowserRouter as Router, Route, Switch } from "react-router-dom";
//import './App.css';

// assets css
import "./assets/frontend/style/main.css";
// assets vendor
import "assets/frontend/vendor/animate.css/animate.min.css";
import "assets/frontend/vendor/bootstrap-icons/bootstrap-icons.css";
import "assets/frontend/vendor/boxicons/css/boxicons.min.css";
import "assets/frontend/vendor/glightbox/css/glightbox.min.css";
import "assets/frontend/vendor/swiper/swiper-bundle.min.css";
// import "assets/frontend/vendor/glightbox/js/glightbox.min.js";
// import "assets/frontend/vendor/swiper/swiper-bundle.min.js";
// import "assets/frontend/vendor/php-email-form/validate.js";
// import "assets/frontend/vendor/isotope-layout/isotope";
// import "assets/frontend/js/main.js";

function App() {
  return (
    <div className="App">
      <Router>
        <Switch>
          <Route path="/" render={(props) => <FrontendLayout />} />
        </Switch>
      </Router>
    </div>
  );
}

export default App;
